import _createClass from '@babel/runtime/helpers/esm/createClass';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';

var AbstractPlatformProvider = /*#__PURE__*/_createClass(function AbstractPlatformProvider() {
  _classCallCheck(this, AbstractPlatformProvider);
});

export { AbstractPlatformProvider };
